export default {"src":"/_next/static/media/height-icon.904c4a6d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};